import React from 'react';

const NavButton = (props) => (
    <i id="navButton" className="fas fa-bars" onClick={props.handleClick}></i>
);

export default NavButton;